import React, { useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { formatEuro } from '../../functions/formatNumber';
import CustomOrderArrow from './IconosOrdenacion';
import AppContext from '../AppContext';
import { getColorForAmount } from '../../functions/colors';

const TipusMovimentItem = ({tmovData}) => {
  const value = tmovData;

  const { userapp: paramUserapp } = useParams();
  const userapp = paramUserapp;

  const navigate = useNavigate();
  const handleListMov = (tmov) => {
    const param = encodeURIComponent(tmov.nomMoviment);
    navigate(`/${userapp}/dashboard/concepte/${tmov.concepte.nom}/tipusmov/${param}`);
  };    

  const { conceptesList } = useContext(AppContext);
  const conceptObj = conceptesList?.find(c => c.nom === value.concepte?.nom);
  const isInvestment = conceptObj?.tipus === 'INVERSIO';

  const colorImport = getColorForAmount(value.importAgregat.saldo, isInvestment);
  return (
    <Grid container spacing={2} alignItems="center" 
      onClick={() => handleListMov(value)}
      sx={{ 
        marginBottom: 1,
        paddingLeft: '10px',
        paddingRight: '10px',
        transition: 'background-color 0.3s',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)', // Cambia el color de fondo al pasar el ratón
        },
      }}>

      <Grid size={{xs: 12, sm: 6 }}>
        <Typography variant="body1">
          {value.nomMoviment}
        </Typography>
      </Grid>

      <Grid size={{xs: 12, sm: 2 }} container direction="column" alignItems="flex-end" >
        <Typography variant="body1">
          {formatEuro(value.importAgregat.mitjaSaldo)}
        </Typography>
      </Grid>

      <Grid size={{xs: 12, sm: 2 }} container direction="column" alignItems="flex-end" >
        <Typography variant="small">
          {value.importAgregat.numMoviments}
        </Typography>
      </Grid>

      {/* Columna derecha: Saldo del mes y saldo acumulado */}
      <Grid size={{xs: 12, sm: 2 }} container direction="column" alignItems="flex-end" 
        sx={{ gap: '1px' }}>
        <Typography variant="body1" fontWeight="bold" color={colorImport} >
          {formatEuro(value.importAgregat.saldo)}
        </Typography>
      </Grid>
    </Grid>
  );
};

const TipusMovimentsList = ({ tmovs }) => {
  const [sortConfig, setSortConfig] = useState({ key: 'data', direction: 'desc' });

  // Función para manejar la ordenación
  const handleSort = (event, key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    event.stopPropagation();
  };

  const listTMovs = Object.values(tmovs);

  // Función para ordenar los balances según el criterio
  const sortedBalances = listTMovs?.sort((a, b) => {
    // Comprobar la clave de ordenación actual
    switch (sortConfig.key) {
      case 'nom':
        return sortConfig.direction === 'asc'
        ? a.nomMoviment.localeCompare(b.nomMoviment)
        : b.nomMoviment.localeCompare(a.nomMoviment);
      case 'mitja':
        // Ordenar por saldo mensual (importes.saldo)
        return sortConfig.direction === 'asc'
        ? a.importAgregat.mitjaSaldo - b.importAgregat.mitjaSaldo
        : b.importAgregat.mitjaSaldo - a.importAgregat.mitjaSaldo
      case 'num':
        // Ordenar por saldo acumulado (importes.saldoAcumulado)
        return sortConfig.direction === 'asc'
        ? a.importAgregat.numMoviments - b.importAgregat.numMoviments
        : b.importAgregat.numMoviments - a.importAgregat.numMoviments
      case 'saldo':
        return sortConfig.direction === 'asc'
          ? a.importAgregat.saldo - b.importAgregat.saldo
          : b.importAgregat.saldo - a.importAgregat.saldo
      default:
        return 0; // Si no hay un criterio de ordenación válido
  }
  });
  
  return (
    <Paper sx={{ padding: '20px' }}>
      {/* Cabecera del Grid */}
      <Grid container spacing={2} alignItems="center" 
        sx={{ 
          marginBottom: 2, 
          backgroundColor: '#f0f0f0', // Fondo claro
          color: '#000', // Texto oscuro
          paddingTop: '2px', 
          paddingBottom: '2px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderBottom: '2px solid #ddd' // Borde inferior
        }}>
        <Grid size={{xs: 12, sm: 6 }}>
          <Typography variant="small" onClick={(e) => handleSort(e, 'nom')}>
              Nom Moviment {sortConfig.key === 'nom' && <CustomOrderArrow direction={sortConfig.direction}/> }
          </Typography>
        </Grid>
        <Grid size={{xs: 12, sm: 2 }} container direction="column" alignItems="flex-end" 
          onClick={(e) => handleSort(e, 'mitja')}>
          <Typography variant="small">
              Mitja {sortConfig.key === 'mitja' && <CustomOrderArrow direction={sortConfig.direction}/> }
          </Typography>
        </Grid>
        <Grid size={{xs: 12, sm: 2 }} container direction="column" alignItems="flex-end" 
          onClick={(e) => handleSort(e, 'num')}>
          <Typography variant="small">
              Num.Movs {sortConfig.key === 'num' && <CustomOrderArrow direction={sortConfig.direction}/> }
          </Typography>
        </Grid>
        <Grid size={{xs: 12, sm: 2 }} container direction="column" alignItems="flex-end" 
          onClick={(e) => handleSort(e, 'saldo')}
          sx={{ gap: '1px' }}>
          <Typography variant="small" >
            Saldo {sortConfig.key === 'saldo' && <CustomOrderArrow direction={sortConfig.direction}/> }
          </Typography>
        </Grid>
      </Grid>    
      
      {/* List Movs */}
      { sortedBalances.map((value) =>  (
        <>
          <TipusMovimentItem key={value.id} tmovData={value}/>
        </>
      )) }
    </Paper>
    );
};

export default TipusMovimentsList;
